import LniRetaliationComplaints from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-complaints';
import LniRetaliationConfirmation from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-confirmation';
import LniRetaliationContact from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-contact';
import LniRetaliationDocuments from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-documents';
import LniRetaliationEmployer from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-employer';
import LniRetaliationForm from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-form';

export default [
    LniRetaliationComplaints,
    LniRetaliationConfirmation,
    LniRetaliationContact,
    LniRetaliationDocuments,
    LniRetaliationEmployer,
    LniRetaliationForm,
];